export enum TRADE_STATUS {
  UN_BROADCAST = 'unbroadcast',
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
  TIMEOUT = 'timeout',
  INVALID = 'invalid',
}

export enum TRADE_TYPE {
  INSTANT,
  STAKING,
}
